import { useCallback, useState } from 'react'

export default function useSelection() {
    const [selectMode, setSelectMode] = useState(false)
    const [selected, setSelected] = useState(() => new Set())

    const enterSelectMode = useCallback(() => setSelectMode(true), [])

    const exitSelectMode = useCallback(() => {
        setSelectMode(false)
        setSelected(new Set())
    }, [])

    const toggle = useCallback((id) => {
        setSelected((prev) => {
            const next = new Set(prev)
            if (next.has(id)) next.delete(id)
            else next.add(id)
            return next
        })
    }, [])

    const selectAll = useCallback((ids) => setSelected(new Set(ids)), [])
    const clear = useCallback(() => setSelected(new Set()), [])

    return { selectMode, selected, enterSelectMode, exitSelectMode, toggle, selectAll, clear }
}
